import { useState } from 'react'
import type {
  CursorPagination,
  CursorPaginationState,
} from './useCursorPagination.types'

const INITIAL_STATE: CursorPaginationState = { cursor: null, history: [] }

export function useCursorPagination(): CursorPagination {
  const [state, setState] = useState<CursorPaginationState>(INITIAL_STATE)

  function next(cursor: string | null | undefined) {
    if (!cursor) return

    setState((current) => ({
      cursor,
      history: [...current.history, current.cursor],
    }))
  }

  function previous() {
    setState((current) => {
      const cursor = current.history.at(-1)

      if (cursor === undefined) return current

      return { cursor, history: current.history.slice(0, -1) }
    })
  }

  function reset() {
    setState(INITIAL_STATE)
  }

  return {
    cursor: state.cursor,
    hasPrevious: state.history.length > 0,
    next,
    previous,
    reset,
  }
}
